import React, { useEffect, useState } from "react";
import { formatRelative } from "@/utils/formatters";

/**
 * Live · Updated N ago — pulsing green dot + real timestamp.
 * `fetchedAt` should be a Date or ISO string set on every successful fetch.
 */
export default function LiveIndicator({ fetchedAt, label = "Updated" }) {
  const [text, setText] = useState("just now");

  useEffect(() => {
    if (!fetchedAt) return;
    const tick = () => setText(formatRelative(fetchedAt));
    tick();
    const id = setInterval(tick, 30_000);
    return () => clearInterval(id);
  }, [fetchedAt]);

  return (
    <span
      data-testid="live-indicator"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontFamily: "var(--font-body)",
        fontSize: 12,
        color: "var(--slate-500)",
      }}
    >
      <span
        aria-hidden
        style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          background: "#2D7A4A",
          boxShadow: "0 0 0 0 rgba(45,122,74,0.4)",
          animation: "opsoraPulse 2s infinite",
        }}
      />
      Live · {label} {text}
    </span>
  );
}
